import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../shared';
import { CNAEFormControlTextComponent } from './cnae-form-control-text.component';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        CNAEFormControlTextComponent
    ],
    exports: [
        CNAEFormControlTextComponent
    ]
})
export class CNAEFormControlTextModule { }
